module.exports = __webpack_public_path__ + "img/gc.0dd9316b.png";